<template>
  <a-modal 
    width="70%"
    :title="$t('supervise.personalFence')"
    v-model="visable"
    centered
    @ok="handleOk"
    destroyOnClose
  >
    <template slot="footer">
      <a-button type="primary"  @click="handleOk">
        {{$t('global.cancel')}}
      </a-button>
    </template>
    <!-- 个人围栏没有数据，用户可以创建个人围栏 -->
    <div v-if="!hasPersonalFence" class="addFence">
      <AddPersonalFence @addOk="addFenceComplete" :personId="personid" :personInfo="personInfo" />
    </div>
    <!-- 个人围栏存在，用户可以修改或删除个人围栏 -->
    <div v-else class="content">
      <a-carousel>
        <a class="slide" slot="customPaging" slot-scope="props">
          <div class="item">{{props.i}}</div>
        </a>
        <template v-for="(item, index) in mapsData">
          <div :key="index + Math.random()">
            <ShowFence
              v-if="fenceStatus[index] === 'show'"
              :item="item"
              :index="index"
              @deleteFence="deleteFence"
              @editFence="editFence"
            />
            <EditFence
              v-else
              :item="item"
              :index="index"
              @commitEdit="commitEdit"
              @quitEdit="quitEdit"
            />
          </div>
        </template>
      </a-carousel>
    </div>
  </a-modal>
</template>
<script>
import PersonalFenceMap from '@components/common/PersonalFenceMap'
import ShowFence from '@components/personalFence/showFence'
import EditFence from '@components/personalFence/editFence'
// import BMap from '../../components/common/BMap'
import AddPersonalFence from './AddPersonalFence'
import config from '../../config/'
import {
  secondsToTime,
  timeToSeconds
} from '../../utils/formatTime'
import moment from 'moment'
export default {
  components: {
    PersonalFenceMap,
    AddPersonalFence,
    // BMap,
    ShowFence,
    EditFence
  },
  data () {
    return {
      fenceStatus: ['show', 'show'],
      personInfo: '',
      visable: false,
      opt: '',
      startTime: 0,
      endTime: 0,
      mapsData: [],
      personid: '',
      mapsChangeData: [],
      fenceName: ''
      // disabled: [false, false]
    }
  },
  computed: {
    disabled () {
      let arr = []
      for (let i = 0; i < this.mapsData.length; i++) {
        let hasChangeData = (id) => {
          return this.mapsChangeData.some((item) => item.id === id )
        }
        arr[i] = hasChangeData(this.mapsData[i].id) ? false : true
      }
      return arr
    },
    hasPersonalFence () {
      return this.mapsData.length > 0 ? true : false
    }
  },
  methods: {
    // 初始化设定
    init () {
      this.fenceStatus = ['show', 'show']
      this.fenceStatus = [...this.fenceStatus]
    },
    // 切换围栏的显示和修改状态
    editFence (index) {
      // 需要变异方法
      // console.log(`要修改第${index}个围栏`)
      this.fenceStatus[index] = 'edit'
      this.fenceStatus = [...this.fenceStatus]
      // console.log(this.fenceStatus)
    },
    // 切换围栏的显示和修改状态
    quitEdit (index) {
      this.fenceStatus[index] = 'show'
      this.fenceStatus = [...this.fenceStatus]
    },
    // 提交修改
    commitEdit (fenceData) {
      // console.log(fenceData)
      this.modifFence(fenceData)
    },
    // 删除围栏
    deleteFence(id) {
      let confirmDelete = confirm(this.$t('global.confirm'))
      // console.log(confirmDelete)
      if (confirmDelete) {
        // console.log(id)
        this.$http.delete(config.api.delete_personnal_fence + id).then((res) => {
          // console.log(res)
          if (res && res.code === 0) {
            this.$notification.open({
              message: this.$t('global.commitSuccess')
            })
            // 页面获取数据初始化
            this.getPersonFenceData(this.personid).then(() => {
              this.init()
            })
          }
        })
      }
    },
    // 添加个人围栏完成后的回调
    addFenceComplete () {
      this.getPersonFenceData(this.personid).then(() => {
        this.init()
      })
    },
    // 提交围栏修改
    modifFence (data) {
      console.log(data)
      this.$http.put(config.api.put_personnal_fence, data).then((res) => {
        // console.log(res)
        let {code, desc, result} = res
        // 如果请求的结果是成功的，那就整理数据并赋值
        if (code === 0 && result) {
          this.$notification.open({
            message: this.$t('global.commitSuccess'),
            icon: <a-icon type="smile" style="color: #108ee9" />,
          })
          this.getPersonFenceData(this.personid).then(() => {
            this.init()
          })
          // this.init()
        } else {
          this.$notification.open({
            message: `${desc}`
          })
        }
      })
    },
    // 点击确定按钮
    handleOk () {
      // console.log('ok')
      this.visable = false
    },
    // 显示当前的modal本身
    showModal (options) {
      this.personInfo = options
      this.personid = options.key
      this.getPersonFenceData(options.key).then(() => {
        this.visable = true
      })
    },
    // 向后台请求当前用户的个人围栏配置数据
    getPersonFenceData (id) {
      return new Promise((resolve, reject) => {
        this.$http.get(config.api.get_personal_fence + `${id}`).then((res) => {
          console.log(res)
          let {code, desc, result} = res
          if (code === 0 && desc === 'success' && result) {
            this.mapsData = result
            resolve()
          }
        })
      })
      
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  // background-color: aqua;
  .personal-fence {
    width: 100%;
    // background: #666;
    padding: 5px 0;
    div {
      padding-bottom: 10px;
    }
  }
}
</style>


